!function(name, module, context) {
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if (window.define)
		define('common/filter',[ 'vendor/mustache','libs/ct_view', 'libs/ct_store' ], module)
	else
	//>>excludeEnd("requireTmpl");
		context[name] = module(Mustache, CT.View, CT.store)


}('commonFilter', function(Mustache, View, store) {

	var commonFilter = {

			getFilterSettingsName:function(_name){ // mainly used only for slider filters, no need to add checkbox-type filter-names.
				var sectorFilters = ["price","departureTime"];
				return _.filter(sectorFilters,function(_sectorFlt){
					return (_name.indexOf(_sectorFlt)!=-1);
				})[0] || _name;
			},
		/*
		 * @DESC : create filter skeleton along with filter
		 */
		getUrlParameter : function (sParam) {
			var sPageURL = window.location.search.substring(1),
					sURLVariables = sPageURL.split('&'),
					sParameterName,
					i;
	
			for (i = 0; i < sURLVariables.length; i++) {
					sParameterName = sURLVariables[i].split('=');
	
					if (sParameterName[0] === sParam) {
							return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
					}
			}
		},
		createFilter: function(name, type, settings, filterTabId) {
			settings = settings || {}, tmp
			var $filtersForm = this.$el.find('.filtersForm'), filterSettings, typeAttr = type.split('.'), tmp;
			if(window.altFilters == "true" && name == "destinationsTheme"){
				var $filtersForm = this.$el.find('.altFiltersForm');
				
			}
			var $filterCtn = (CT.app == 'air')?$filtersForm.find(".commonFilters"): $filtersForm;
			if(filterTabId != null){
				$filterCtn = (CT.app == 'air')?$filtersForm.find(".sectorFilters .sectorBlock[data-idx='"+ filterTabId +"']"): $filtersForm;
			}

			function updateSettings(/* object */ updateObj, /* array */ attributes) {
				attributes.splice(0,1);
				_.forEach(attributes, function(attr) {
					switch(attr) {
						case 'left': updateObj.hideHandle = 'last';
							break;
						case 'right': updateObj.hideHandle = 'first';
							break;
					}
				});
			}
			//add extra params to settings if necessary
			settings.widget = typeAttr[0];
			settings.name = name;
			
			filterSettings = CT.settings[CT.app];
			

			//Just to have location based title which is handled form UI 
			//In case if we have to show custome localities filter it will be used to show header
			/*
			if( CT && CT.app && CT.app == 'hotel' && name == 'topLocation'){
				var currentCityFilter = (CT.settings.filterTypes[typeAttr[0]], filterSettings.filter[name])[city];
				filterSettings = $.extend({}, currentCityFilter || {});	
			} else{
				filterSettings = $.extend({}, CT.settings.filterTypes[typeAttr[0]], filterSettings.filter[name] || {});
			}
			*/

			filterSettings = $.extend({}, CT.settings.filterTypes[typeAttr[0]], filterSettings.filter[name] || {});
			filterSettings = $.extend({}, filterSettings, settings);
			updateSettings(filterSettings, _.clone(typeAttr));

			//copy the global settings and settings params into the application level settings
			CT.settings[CT.app].filter[name] = $.extend(true, {}, filterSettings);
			
			if(window.altFilters == "false" && filterSettings.addAltFiltersClass && CT.subProd == "wg"){
				filterSettings.addAltFiltersClass = false;
			}

			if(name == 'nearByCities')
				tmp = 'prepend';
			else
				tmp = 'append';

			if(window.isMobileUA){
				$filterCtn[tmp](CT.to_html('FilterSkeletonMobileTpl', filterSettings));
			}else{
				if(CT.app == 'hotel'){
					filterSettings.isNewFilterEnabled  = CT.settings.hotel.filter.isNewFilterEnabled;
					if(filterSettings.name == "locality"){
						var cityName = this.getUrlParameter('city');
						filterSettings.title = 'Popular in '+cityName;
					}
				}
				if (name === "tagsFilter") {
					filterSettings.title = "Popular for " + CT.cache[CT.settings.currentTab].searchParams.all.city;
				}
				if (name === "lolfilter") {
					filterSettings.title = "Top localites in " + CT.cache[CT.settings.currentTab].searchParams.all.city;
				}
				$filterCtn[tmp](CT.to_html('FilterSkeletonTpl', filterSettings));
			}


			if(!(type.indexOf('slider') >= 0))
				this.updateFilter(name, filterSettings);
			return this
		},

		createSectorFiltersSkeleton : function(sectors){
			var $filtersForm = this.$el.find('.filtersForm'),$sectorFilters;
			var $tabs, $sectorBlock;
			sectors = (function(_sectorsHash){ // if this function is reused , move this as a seperate method of filters.
				var modifiedSectorsHash = [];
				_.each(_sectorsHash,function(sectorIdx, sectorKey){
					modifiedSectorsHash.push({idx: sectorIdx,name: sectorKey})
				});
				return modifiedSectorsHash;
			})(sectors);


			$filtersForm.append(CT.to_html('FilterSectorsTpl', { sectors:sectors, sectorDisplayIdx:function(){return (this.idx +1);} }));
			//preselecting the first filter tab..
			$tabs = $filtersForm.find(".sectorTabs");
			$sectorBlock = $filtersForm.find(".sectorFilters");
			$tabs.find("li[data-idx='0']").addClass("current");
			$sectorBlock.find(".sectorBlock").hide().end().find(".sectorBlock[data-idx='0']").show();
		},



			/*
			 * @DESC: 'show all' link click handle in case of checkbox filter
			 */
			triggerCheckboxShowAll: function(e) {
				e.preventDefault();
				window.remvoeActiveClassFromTag = false;
				var $element = $(e.target);
				var isSmartFilter = $element.closest(".sideBlock").hasClass("smartFilters");
				var filter = $element.attr('data-filter-name');
				
				$element.hide();

				if(CT.app == 'hotel' && CT.settings.hotel.filter.isNewFilterEnabled){

	                CT.utils.helperFunctions.trackMixpanelEvent('Hotel_SRP_ClearFilter_Clicked', {
	                    'filterType': filter
	                });
	                CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Cleared", {
				    	"filterType": filter,
				    	"showAllType": filter
				    });
					$element = $("div.filterContent-"+ filter +" input").removeAttr('checked');
				} else {
					$element = $element.parent().find("div.filterContent input").removeAttr('checked');
				}

				if(isSmartFilter){
					$element.removeAttr('checked');
				}
				else {
					$element.attr('checked', 'checked');
				}

				if(CT.app === 'air')
				{
					CT.fire("logfilterShow",[{linkClick:'filter_ShowAll'}]);
				}
				
				this.fltData(e);
			},







			/*
			 * @DESC : hide filter type based on the name passed
			 */
			hideFilter: function(name) {
				if(name) {
					this.$el.find('.' + name).parents('.sideBlock').hide();
				}
			},




			/*
			 * @DESC: 'only' link click handle in case of checkbox filter
			 */
			triggerShowOnly: function(e) {
				var $element = $(e.target);

				e.preventDefault();
				$element.parents('nav').find('input:not([value=MULTI])').removeAttr('checked');
				$element.parent().find('input').attr('checked', 'checked');
				
				if(CT.app === 'air'){
					CT.fire("logfilterShow",[{linkClick:'filter_ShowOnly'}]);
				}
				
				this.fltData(e);
			},












			/**
			 * @usage - 1) this.toggleFilter('price') // toggle 'price' filter
			 * @usage - 2) this.toggleFilter(e) // when clicked
			 * @usage - 3) this.toggleFilter('price', 'show') // specify exactly the type of toggle
			 * @usage - 4) this.toggleFilter('*') // toggle all filters
			 */
			toggleFilter : function(e, actionType){
				var $elements, all = e === '*', actionClass
				var cls = 'closed opened'
				var actionToClassMapping = {
					hide: 'closed',
					show: 'opened'
				}
				var statusToArrowMapping = {
					closed: 'rArrow',
					opened: 'dArrow'
				}
				//@private
				var _toggle = function($elems, actionCls){
					return $elems.removeClass(cls).addClass(actionCls).find('h5>i:first-child').removeClass('rArrow dArrow').addClass(statusToArrowMapping[actionCls])
				}
				var _getClass = function($elems, actionType){
					return actionType && actionToClassMapping[actionType] || ($elems.hasClass('closed')? 'opened' : 'closed')
				}

				if(_.isString(e)) // case 1) and 3) and 4)
					$elements = this.$(CT.settings.selectors.filterForm).find(all? '.sideBlock' : '.'+e)[all? 'identity' : 'closest']('.sideBlock')
				else if(e.target) // case 2)
					$elements = $(e.currentTarget).parents('.sideBlock');
				_toggle($elements, _getClass($elements, actionType));
				/*if(CT.subProd && CT.subProd =="wg"){
					$($(CT.settings.selectors.filterForm).closest("aside")[1]).stick_in_parent()
					$($(CT.settings.selectors.filterForm).closest("aside")[1]).stick_in_parent({parent:$($(CT.settings.selectors.filterForm).closest("aside")[1]),offset_top:55});
					$(document.body).trigger("sticky_kit:recalc")
				}*/
				CT.fire('onFilterToggled',[e,_getClass($elements, actionType)]);
				return this
			},






			/**
			 * @DESC Updates filter UI based on updated settings
			 */
			updateFilter : function(name, settings, selector,destroyExisting){
				$currentResultContainer = $('#ResultContainer_' + CT.settings.currentTab);
				var $filterContainer  = (selector) ? $currentResultContainer.find('.filtersForm '+selector) : $currentResultContainer.find('.filtersForm .' + name),
					html, tmp;
				if(window.altFilters == "true" && name == "destinationsTheme" && settings != null){
					$filterContainer  = (selector) ? $currentResultContainer.find('.altFiltersForm '+selector) : $currentResultContainer.find('.altFiltersForm .' + name)
					settings.radioInput = true;
				}
				settings = $.extend({}, CT.settings[CT.app].filter[name], settings || {})

				switch(settings.widget) {
					case 'inputText':
						if(CT.app == 'hotel'){
							settings.tabId = CT.settings.currentTab;
							settings.isNewFilterEnabled  = CT.settings.hotel.filter.isNewFilterEnabled;
						}
						html = CT.to_html('InputTextFilterTpl', settings);
						$filterContainer.html(html);
						if(settings.autoComplete != null && settings.autoComplete == true){
							$("p."+settings.name).find("input").autocomplete();
						}
						break;
					case 'slider':
						if(destroyExisting){
							$filterContainer.html("").slider("destroy");
						}
						tmp = $filterContainer.priceslider(settings);
						if(settings.disabled)
							tmp.slider('disable');
						if((tmp = $filterContainer.parent().find('.displayStaticRange'))) {
							tmp.find('.fLeft').html(CT.utils.formatForCurrency(settings.min));
							tmp.find('.fRight').html(CT.utils.formatForCurrency(settings.max));
						}
						if(settings.hintCheckBox){
							this.$el.find('.filtersForm #'+settings.hintCheckBoxId)[(settings.checkAll)?"attr":"removeAttr"]("checked","checked");
						}
						break;
					case 'checkbox':
						if(CT.app == 'hotel'){
							settings.tabId = CT.settings.currentTab;
							settings.isNewFilterEnabled  = CT.settings.hotel.filter.isNewFilterEnabled;
						}
						html = CT.to_html('CheckboxFilterTpl', settings);
						$filterContainer.html(html);
						break;
					case 'popup':
						if(CT.app == 'hotel')
							settings.tabId = CT.settings.currentTab;
						html = CT.to_html('QuoteTmpl',settings);
						$filterContainer.html(html);
						break;
					case 'radio':
					    if(CT.app == 'hotel'){
							settings.tabId = CT.settings.currentTab;
							settings.isNewFilterEnabled  = CT.settings.hotel.filter.isNewFilterEnabled;
						}
					    html=CT.to_html("CheckboxFilterTpl",settings);
					    $filterContainer.html(html);
					    break;
						
				}

				return this
				//($handle = $slider.find('.rangeHandle')).attr('data-width', ($handleWidth = ($handle.width() - 2)));
				//return $slider.width($parentSlider.width() - $handleWidth)
			},







			/**
			 * returns unique flight names mustache template json.
			 * @flobj = flight object
			 */
			getUniqueAirline : function (solution){
				var airlineCode = []
				, airData={AIRCODE:[]}
				, tempArr = []
				, arNames = flObj.jsons.airline_names;


				_.forEach(solution.content, function (i, val){
					if(i.oa !== 'S2') airlineCode.push(arNames[i.oa]+'||'+i.oa);//airline name and airline code
				});
				airlineCode = (_.uniq(airlineCode)).sort();//making unique and sorting alphabetical
				_.each(airlineCode, function(value, index) {// creating mustache json
					var airlineArr = value.split('||');
					airData.AIRCODE.push({"flightCode":airlineArr[1],"flightName":airlineArr[0],"extra":"data-flt=airLine"});//mustache json
				});
				return airData;//return mustache json
			},




			//TODO is this being used??
			applyfilters : function(settings, masterFilterObj, container, item){
				var eleCount = 0, eleArrArr = []
				, classes = []
				, $container = container || $('#ResultContainer_' + CT.settings.currentTab + ' .viewController')
				, item = item || 'li.listItem', eleBlocks = []
				, filterObj = $.extend(true, {}, masterFilterObj)
				, clusterHotelsId = ''
				, allItems, attrKey, inRange;

				//remove all separators
				$container.find('.separatorMessage').remove();


				_.forEach(filterObj, function(eachFilter, key) {
					if (eachFilter.length == 0) {
						delete filterObj[key];
					}
				});

				if ($.isEmptyObject(filterObj)) {
					$container.find(item).removeClass('filtered').show();
					//update showingCount
					eleCount = $container.find(item).length;
				} else {
					//hide all the elements and remove filtered class
					allItems = $container.find(item).removeClass('filtered').hide();
					//take the elements provided when clicked on map cluster
					if (filterObj[settings.ids]) {
						_.forEach(filterObj[settings.ids], function(eachLocBlock, index) {
							if (index != 0) {
								clusterHotelsId += ",#" + eachLocBlock;
							} else {
								clusterHotelsId += "#" + eachLocBlock;
							}
						});
						eleBlocks.push($container.find(clusterHotelsId));
					}
					//take the elements provided when a location filter is triggered
					else if (filterObj[settings.loc]) {
						_.forEach(filterObj[settings.loc], function(eachLocBlock) {
							eleBlocks.push($container.find(item + "[" + settings.attrMap[settings.loc] + "='" + eachLocBlock + "']"));
						});
					}
					//take all the listitem elements for filtering
					else {
						eleBlocks.push(allItems);
					}

					_.forEach(eleBlocks, function(eleArr) {
						eleArr.removeClass('filtered').hide();
						//apply all filters to li elements
						_.forEach(filterObj, function(filter, key) {
							//check filter settings for the condition ( "or" or "and" condition )
							if (settings.or.indexOf(key) >= 0) {
								_.forEach(filter, function(eachVal, index) {
									if ( attrKey = settings.attrMap[key]) {
										filter[index] = "[" + attrKey + "~='" + eachVal + "']";
									} else {
										filter[index] = '.' + eachVal.toString();
									}
								}, this);
								classes.push(filter.join(','));
							} else if (settings.and.indexOf(key) >= 0) {
								_.forEach(filter, function(eachVal) {
									if ( attrKey = settings.attrMap[key]) {
										classes.push("[" + attrKey + "~='" + eachVal + "']");
									} else {
										classes.push('.' + eachVal.toString());
									}
								}, this);

							}
						}, this);

						_.forEach(classes, function(classStr, key) {
							eleArr = _.filter(eleArr, function(ele) {
								var eleTag = $(ele);

								return (eleTag.is(classStr) || (eleTag.find(classStr).length > 0));
							});
						});

						//apply range filters
						_.forEach(settings.range, function(eachRangeFilter) {
							if (filterObj[eachRangeFilter]) {
								eleArr = _.filter(eleArr, function(ele) {
									var itemVal;

									//do not consider unavailable hotels for price filter
									if(eachRangeFilter == "price" && $(ele).is(".NA")) {
										return true;
									}
									itemVal = parseInt($(ele).attr(settings.attrMap[eachRangeFilter]));

									if (itemVal >= filterObj[eachRangeFilter][0] && itemVal <= filterObj[eachRangeFilter][1]) {
										return true;
									}
									return false;
								});
							}
						});

						eleCount += eleArr.length;
						eleArrArr.push(eleArr);

					}, this);

				}
				return {"eleCount":eleCount,"eleArr":eleArrArr}; // TODO: change json attribute eleArrArr
			}



		}// - commonfilter brace end.


	return commonFilter;
}, CT.settings);

